import type { Condition, Reference } from '@medplum/fhirtypes'
import { Diagnosis } from '@seen/core/models/conditions/Diagnosis'
import type { JSX } from 'react'
import { IconCondition } from '#src/components/icons/IconCondition.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ConditionOption({
  condition,
  suffix,
}: {
  condition: Reference<Condition>
  suffix?: string
}): JSX.Element {
  const { data: instance } = useRead(Diagnosis, condition)
  return (
    <div className="flex items-center gap-2">
      <div className="p-0.5">
        <IconCondition className="size-4 shrink-0" />
      </div>
      <span>
        {instance?.name}
        {suffix && <span className="text-muted-foreground"> {suffix}</span>}
      </span>
    </div>
  )
}
